import Select from 'react-select'
import axios from 'axios'
import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {KTSVG, useDebounce} from '../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import {GetAllComment, UserIdForComment} from '../../../Redux/AdminPanel/CommentSlice'

import CreateUserAccount from './Modal/CreateUserAccountPopup'
import './UserList.scss'
import {ProfileDetailData} from '../../../Redux/AdminPanel/ProfileDetailsSlice'
import {AccountTypeOptions, IndustryOptions} from './Constant/CellCastConstant'
import {Check} from 'react-bootstrap-icons'
import {
  DeleteUserAccount,
  getAccountIdList,
  GetAllAccountId,
  GetAllUserAccount,
  UpdateStatus,
} from './UserListSlice/UserListSlice'
import {AuthenticateUser, StatusColor} from '../../../Utils/_helpers/RoleAndPermission'
import {GeneralDataOFLoginUser} from '../../../Utils/Auth'
import {GetAllStaff} from '../MyProfile/Staff_Account/StaffAccountSlice/StaffAccountSlice'
import NodataYet from '../../../Components/NodataYet'
import {DropdownButton, Dropdown} from 'react-bootstrap'
import {ENV} from '../../../Utils/_helpers/EnvHelper'
import {
  useAdminUpdateSmsStatusMutation,
  useAdminUpdateUserTagMutation,
  useAdminUpdateUserVerifiedEmailMutation,
} from '../../../../services/cellcast'
import {toast} from 'react-toastify'
import clsx from 'clsx'
import { getAllUserDetails } from '../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'

const AllCellCastUserList = () => {
  const isUserWhiteLabel = GeneralDataOFLoginUser()?.isWhiteLabelUser === true
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [subUser, setSubUser] = useState(false)
  const API_URL = ENV().REACT_APP_API_URL
  const [tags, setTags] = useState<any>([])
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const [checkList, setCheckList] = useState<any>([])
  const [checkTag, setCheckTag] = useState<any>([])
  const [userId, setUserId] = useState<any>('')
  const [commentMsgBox, setCommentMsgBox] = useState<any>(false)
  const accountIdList = useSelector(getAccountIdList)
  const [apply, setApply] = useState(false)
  const [filterOpen, setFilterOpen] = useState(false)
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
  })
  const [filter, setFilter] = useState<any>({
    industry: {value: '', label: 'Select Industry'},
    status: {value: '', label: 'Select Status'},
    accountId: {value: '', label: 'Select Account'},
    accountType: {value: '', label: 'Select Account Type'},
    accountManager: {value: '', label: ''},
    sales: {value: '', label: ''},
  })

  const userDetail: any = useSelector(getAllUserDetails)

  /////////USE SELECTOR//////////////////////////////////////
  const userAccList = useSelector((state: any) => state?.UserAccount?.userAccountList)
  const debouncedSearchTerm = useDebounce(page?.search, 500)

  const userRole = GeneralDataOFLoginUser()?.role
  const userRoleId = GeneralDataOFLoginUser()?._id

  useEffect(() => {
    if (userRole === 'accountManager') {
      setFilter({
        accountManager: {value: userRoleId, label: 'Filter By Account Manager'},
      })

      setApply(true)
    }

    if (userRole === 'sales') {
      setFilter({
        sales: {value: userRoleId, label: 'Filter By Sales'},
      })

      setApply(true)
    }
  }, [])

  useEffect(() => {
    if (page.page || page.size) {
      let filterData = {
        role: filter?.role?.value,
        industry: filter?.industry?.value,
        status: filter?.status?.value,
        accountId: filter?.accountId?.value,
        accountType: filter?.accountType?.value,
        accountManager: filter?.accountManager?.value,
        sales: filter?.sales?.value,
      }

      let x = tags.map((key: any) => key.value)
      dispatch(GetAllUserAccount({...filterData, features: x.join(','), ...page}))
    }
  }, [debouncedSearchTerm, page.page, page.size, apply])

  useEffect(() => {
    dispatch(GetAllStaff({page}))
    if (!isUserWhiteLabel) {
      dispatch(GetAllAccountId())
    }
  }, [])

  const handleCheckAll = () => {
    if (checkList?.length == userAccList?.items?.length) {
      setCheckList([])
    } else {
      let list = userAccList?.items?.map((key: any) => key._id)
      setCheckList([...list])
    }
  }
  const options = [
    {value: 'Quick Message', label: 'Quick Message'},
    {value: 'Reviews', label: 'Reviews'},
    {value: 'API', label: 'API'},
    {value: 'Campaign', label: 'Campaign'},
    {value: 'Automation', label: 'Automation'},
    {value: 'Lead Generation', label: 'Lead Generation'},
  ]
  const handleCheck = (e: any) => {
    if (checkList?.includes(e.target.value)) {
      checkList.splice(checkList?.indexOf(e.target.value), 1)

      setCheckList([...checkList])
    } else {
      setCheckList([...checkList, e.target.value])
    }
  }

  const handleSelect = (id: any) => {
    setOpen(true)
    setDeleteIds([id])
  }

  //IF get confirmation from popup it will delete
  useEffect(() => {
    if (confirm == true) {
      dispatch(
        DeleteUserAccount({
          userIds: deleteIds,
        })
      )
      setCheckList([])
      setConfirm(false)
    }
  }, [confirm])

  const handleDeleteAll = () => {
    setOpen(true)
    setDeleteIds(checkList)
  }
  const DeleteConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        page={page}
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => setCheckList([])}
        Message={'Are you sure, you want to delete this user? '}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  const handleExport = () => {
    let x = tags.map((key: any) => key.value)
    const newObject: any = {}

    // Extracting values and creating a new object
    Object.keys(filter).forEach((key) => {
      newObject[key] = filter[key].value
    })
    axios
      .get(`${API_URL}admin/getAllUserAccount`, {
        params: {
          ...page,
          ...newObject,
          features: x.join(','),
          export: true,
          exportArr: checkList?.join(','),
        },
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res: any) => {
        window.open(`${API_DOMAIN}${res.data.data.downloadurl}`, '_self')
        setCheckList([])
      })
  }

  const handleComment = (id: any) => {
    setCommentMsgBox(true)
    dispatch(UserIdForComment({id: id}))
    AuthenticateUser('see-credit-history') &&
      dispatch(
        GetAllComment({
          userId: id?._id,
        })
      )
  }

  const CreateCellCastOwner = useMemo(
    () => <CreateUserAccount show={subUser} handleClose={() => setSubUser(false)} />,
    [subUser]
  )

  const [updateSmsStatus, {isLoading: isUpdateSmsStatus}] = useAdminUpdateSmsStatusMutation()
  const [updateUserTag, {isLoading: isUpdateUserTag}] = useAdminUpdateUserTagMutation()
  const [updateUserVerifiedEmail, {isLoading: isUpdateUserVerifiedEmail}] = useAdminUpdateUserVerifiedEmailMutation()

  const handleUpdateSmsStatus = (userId: string, userStatus: string) => {
    let statusUpdate = 'approved' // original status
    if (userStatus === 'approved') {
      statusUpdate = 'newUser'
    }

    updateSmsStatus({
      userId: userId,
      status: statusUpdate,
    })
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error verify user:', res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
      .finally(() => {
        if (page.page || page.size) {
          let filterData = {
            role: filter?.role?.value,
            industry: filter?.industry?.value,
            status: filter?.status?.value,
            accountId: filter?.accountId?.value,
            accountType: filter?.accountType?.value,
          }

          let x = tags.map((key: any) => key.value)
          dispatch(GetAllUserAccount({...filterData, features: x.join(','), ...page}))
        }
      })
  }

  const handleUpdateUserTag = (userId: string, tag: string, action: string) => {
    updateUserTag({
      userId: userId,
      tag: tag,
      action: action,
    })
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error verify user:', res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
      .finally(() => {
        if (page.page || page.size) {
          let filterData = {
            role: filter?.role?.value,
            industry: filter?.industry?.value,
            status: filter?.status?.value,
            accountId: filter?.accountId?.value,
            accountType: filter?.accountType?.value,
          }

          let x = tags.map((key: any) => key.value)
          dispatch(GetAllUserAccount({...filterData, features: x.join(','), ...page}))
        }
      })
  }

  const handleUpdateUserVerifiedEmail = (userId: string, status: boolean) => {
    updateUserVerifiedEmail({
      userId,
      status,
    })
      .then((res) => {
        if ('data' in res) {
          console.log(res.data, 'here res data')
          toast.success(res.data?.message)
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error verify user:', res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
      .finally(() => {
        if (page.page || page.size) {
          let filterData = {
            role: filter?.role?.value,
            industry: filter?.industry?.value,
            status: filter?.status?.value,
            accountId: filter?.accountId?.value,
            accountType: filter?.accountType?.value,
          }

          let x = tags.map((key: any) => key.value)
          dispatch(GetAllUserAccount({...filterData, features: x.join(','), ...page}))
        }
      })
  }  

  const getSmsStatusText = (smsStatus: string) => {
    if (smsStatus === 'approved') {
      return <label className='fw-bold fs-7 text-success mt-3 text-nowrap'>Verified Account</label>
    }
    return <label className='fw-bold fs-7 text-danger mt-3 text-nowrap'>Unverified Account</label>
  }

  const getCompletedTag = (tag: string, tags: any) => {
    return tags?.find((it: any) => it.name === tag)
  }

  return (
    <>
      {DeleteConfirmation}
      {CreateCellCastOwner}
      <div className={`sub-accountstable`}>
        <div className='card-header border-0 pt-5'>
          <div className='card-toolbar  mb-1'>
            {checkList?.length > 0 && (
              <>
                <div className='fw-bolder pe-8'>
                  <span className='me-2'>{checkList?.length}</span> Selected
                </div>
                <button type='button' className='btn btn-danger' onClick={handleDeleteAll}>
                  Delete Selected
                </button>
              </>
            )}
          </div>

          <div
            className='card-toolbar'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='hover'
            title='Click to add a user'
          >
            <div className='d-flex align-items-center position-relative my-1'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-6'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14'
                placeholder='Search user'
                value={page?.search}
                onChange={(e) => setPage({...page, search: e.target.value, page: 1, size: 10})}
              />
            </div>
            <div
              onMouseEnter={() => setFilterOpen(true)}
              onMouseLeave={() => setFilterOpen(false)}
              className='filter_parent'
            >
              <button
                className={`btn btn-light-primary ms-3 me-3 filter_btn ${
                  filterOpen && 'show menu-dropdown'
                } `}
                data-kt-menu-placement='bottom-end'
              >
                <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
                Filter
              </button>

              <div
                className={`menu menu-sub menu-sub-dropdown w-250px w-md-300px ${
                  filterOpen && 'show filtermenu'
                }`}
              >
                <div className='px-7 py-5'>
                  <div className='mb-10'>
                    <label className='form-label fw-bold'>Status:</label>

                    <div>
                      <Select
                        name='status'
                        value={filter.status}
                        className='form-select form-select-solid fw-bolder'
                        onChange={(e: any) => setFilter({...filter, status: e, page: 1, size: 10})}
                        options={[
                          {value: '', label: 'Select Status'},
                          {value: 'active', label: 'Active'},
                          {value: 'inactive', label: 'Inactive'},
                          {value: 'suspended', label: 'Suspended'},
                          {value: 'unfinished', label: 'Unfinished'},
                        ]}
                      />
                    </div>
                  </div>
                  {!isUserWhiteLabel && (
                    <div className='mb-10'>
                      <label className='form-label fw-bold'>AccountId:</label>

                      <div>
                        <Select
                          value={filter.accountId}
                          className='form-select form-select-solid fw-bolder'
                          name='accountId'
                          onChange={(e: any) =>
                            setFilter({...filter, accountId: e, page: 1, size: 10})
                          }
                          options={accountIdList?.map((key: any) => ({
                            value: key?._id,
                            label: key?.companyName,
                          }))}
                        />
                      </div>
                    </div>
                  )}

                  <div className='mb-10'>
                    <label className='form-label fw-bold'>Industry:</label>
                    <Select
                      value={filter.industry}
                      className='form-select form-select-solid fw-bolder'
                      name='industry'
                      onChange={(e: any) => setFilter({...filter, industry: e, page: 1, size: 10})}
                      options={IndustryOptions}
                    />
                  </div>

                  <div className='mb-10'>
                    <label className='form-label fw-bold'>Features:</label>
                    <Select
                      value={tags}
                      onChange={(e: any) => setTags(e)}
                      isMulti
                      options={options}
                    />
                  </div>

                  <div className='mb-10'>
                    <label className='form-label fw-bold'>Account Type:</label>
                    <Select
                      value={filter.accountType}
                      className='form-select form-select-solid fw-bolder'
                      name='industry'
                      onChange={(e: any) =>
                        setFilter({...filter, accountType: e, page: 1, size: 10})
                      }
                      options={AccountTypeOptions}
                    />
                  </div>

                  <div className='d-flex justify-content-end'>
                    <button
                      type='reset'
                      className='btn btn-sm btn-white btn-active-light-primary me-2'
                      onClick={() => {
                        const filter = {
                          industry: {value: '', label: 'Select Industry'},
                          status: {value: '', label: 'Select Status'},
                          accountId: {value: '', label: 'Select Account'},
                          accountManager: {value: '', label: ''},
                          sales: {value: '', label: ''},
                        }

                        if (userRole === 'accountManager') {
                          filter.accountManager = {
                            value: userRoleId,
                            label: 'Filter By Account Manager',
                          }
                        }

                        if (userRole === 'sales') {
                          filter.sales = {value: userRoleId, label: 'Filter By Sales'}
                        }

                        setPage({
                          page: 1,
                          size: 10,
                          search: '',
                        })
                        setFilter(filter)
                        setTags([])
                      }}
                    >
                      Reset
                    </button>

                    <button
                      type='submit'
                      className='btn btn-sm btn-primary'
                      data-kt-menu-dismiss='true'
                      onClick={() => {
                        setApply(!apply)
                        setPage({
                          page: 1,
                          size: 10,
                          search: '',
                        })
                        setFilterOpen(false)
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {AuthenticateUser('export-user') && (
              <button onClick={handleExport} type='button' className='btn btn-light-primary me-3'>
                <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                Export
              </button>
            )}

            {AuthenticateUser('create-user') && (
              <button type='button' className='btn btn-primary' onClick={() => setSubUser(true)}>
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                Add User
              </button>
            )}
          </div>
        </div>
        {userAccList?.items?.length > 0 ? (
          <>
            <div className='card-body py-3'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bolder text-muted'>
                      <th className='w-25px'>
                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            value='ALL'
                            data-kt-check='true'
                            data-kt-check-target='.widget-9-check'
                            checked={checkList?.length >= userAccList?.items?.length}
                            onChange={handleCheckAll}
                          />
                        </div>
                      </th>
                      <th className='min-w-150px'>USER</th>
                      <th className='min-w-140px'>COMPANY</th>
                      <th className='min-w-140px'>PHONE</th>
                      <th className='min-w-140px'>Verified</th>
                      <th className='min-w-140px'>STATUS</th>
                      <th className='min-w-150px'>TAGS</th>
                      <th className='min-w-120px'>INDUSTRY</th>
                      <th className='min-w-150px'>FEATURE USED</th>
                      <th className='min-w-150px'>ACCOUNT OWNERS</th>
                      <th className='min-w-150px'>SALES TYPE</th>
                      <th className='min-w-150px'>LAST LOGIN</th>
                      <th className='min-w-150px'>PAYMENT TYPE</th>
                      <th className='min-w-150px'>CREATED ON</th>
                      <th className='min-w-150px'>Total PUNCHED</th>
                      <th className='min-w-150px'>TOTAL SPENT</th>
                      <th className='min-w-150px'>BALANCE</th>
                      <th className='min-w-150px'>LAST PURCHASE</th>
                      <th className='min-w-150px'>LAST SEND</th>
                      <th className='min-w-150px'>LAST SEND SOURCE</th>
                      <th className='min-w-100px text-end'>ACTIONS</th>
                    </tr>
                  </thead>

                  <tbody>
                    {userAccList?.items?.map((data: any, i: number) => (
                      <tr key={i}>
                        <td>
                          <div className='form-check form-check-sm form-check-custom form-check-solid'>
                            <input
                              className='form-check-input widget-9-check'
                              type='checkbox'
                              value={data?._id}
                              checked={checkList?.includes(data?._id)}
                              onChange={handleCheck}
                            />
                          </div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center'>
                            <div
                              onClick={() => {
                                if (AuthenticateUser('edit-user')) {
                                  dispatch(ProfileDetailData(data?._id))
                                  navigate(`/user-profile`)
                                }
                              }}
                              className='symbol symbol-45px me-5 cursor-pointer'
                            >
                              {data?.avatar && data?.avatar !== 'undefined' ? (
                                <img src={data?.avatar} alt='' />
                              ) : (
                                <span className='circle1'>{`${
                                  data?.firstName !== undefined && data?.firstName !== ''
                                    ? data?.firstName?.split('')?.[0]?.toUpperCase() ?? ''
                                    : ''
                                }${
                                  data?.lastName !== undefined && data?.lastName !== ''
                                    ? data?.lastName?.split('')?.[0]?.toUpperCase() ?? ''
                                    : ''
                                }`}</span>
                              )}
                            </div>
                            <div className='d-flex justify-content-start flex-column'>
                              <span
                                onClick={() => {
                                  if (AuthenticateUser('edit-user')) {
                                    dispatch(ProfileDetailData(data?._id))
                                    navigate(`/user-profile`)
                                  }
                                }}
                                className='text-dark fw-bolder text-hover-primary fs-6'
                              >
                                {`${data?.firstName} ${data?.lastName}`}
                              </span>
                              <span
                                onClick={() => {
                                  if (AuthenticateUser('edit-user')) {
                                    dispatch(ProfileDetailData(data?._id))
                                    navigate(`/user-profile`)
                                  }
                                }}
                                className='text-muted fw-bold text-muted d-block fs-7'
                              >
                                {data?.email}
                              </span>
                              {data?.parent && data?.parent != null && (
                                <span className='mt-1 text-muted fw-bold text-muted d-block fs-7'>
                                  child user from{' '}
                                  <span
                                    className='text-hover-primary text-underline'
                                    onClick={() => {
                                      if (AuthenticateUser('edit-user')) {
                                        dispatch(ProfileDetailData(data?.parent._id))
                                        navigate(`/user-profile`)
                                      }
                                    }}
                                  >
                                    <u>{data.parent.name}</u>
                                  </span>
                                </span>
                              )}
                            <div className='d-flex gap-4'>
                              <div className='form-check form-check-sm form-check-custom form-check-solid d-flex flex-column'>
                                <div className='d-flex'>
                                  <input
                                    className='form-check-input me-3 mt-3'
                                    type='checkbox'
                                    checked={data?.smsStatus === 'approved'}
                                    onChange={() =>
                                      handleUpdateSmsStatus(data?._id, data?.smsStatus)
                                    }
                                  />
                                  {getSmsStatusText(data?.smsStatus)}
                                </div>

                                <div>
                                  <input
                                    className='form-check-input me-3 mt-3'
                                    type='checkbox'
                                    checked={data?.isEmailVerified}
                                    onChange={() => {
                                      handleUpdateUserVerifiedEmail(
                                        data?._id,
                                        !data?.isEmailVerified,
                                      )
                                    }}
                                  />

                                  <label
                                    className={clsx(
                                      'fw-bold fs-7 mt-3 text-nowrap',
                                      data?.isEmailVerified
                                        ? 'text-success'
                                        : 'text-danger'
                                    )}
                                  >
                                    {data?.isEmailVerified ? 'Verified' : 'Unverified'} Email
                                  </label>
                                </div>
                                <div className='d-flex'>
                                  <input
                                    className='form-check-input me-3 mt-3'
                                    type='checkbox'
                                    checked={getCompletedTag('demo-completed', data?.tags) ? true : false}
                                    onChange={() => {
                                      const action = getCompletedTag('demo-completed', data?.tags)
                                        ? 'remove'
                                        : 'add'
                                      handleUpdateUserTag(data?._id, 'demo-completed', action)
                                    }}
                                  />

                                  <label
                                    className={clsx(
                                      'fw-bold fs-7 mt-3 text-nowrap',
                                      getCompletedTag('demo-completed', data?.tags)
                                        ? 'text-success'
                                        : 'text-muted'
                                    )}
                                  >
                                    Demo Completed
                                  </label>
                                </div>                                
                              </div>
                              <div className='form-check form-check-sm form-check-custom form-check-solid d-flex flex-column'>
                                <div className='d-flex'>
                                  <input
                                    className='form-check-input me-3 mt-3'
                                    type='checkbox'
                                    checked={
                                      getCompletedTag('review', data?.tags) || getCompletedTag('review-request', data?.tags)
                                        ? true
                                        : false
                                    }
                                    onChange={() => {
                                      const hasOldTag = getCompletedTag('review-request', data?.tags)
                                      const hasNewTag = getCompletedTag('review', data?.tags)

                                      if (hasOldTag || hasNewTag) {
                                        if (hasOldTag) handleUpdateUserTag(data?._id, 'review-request', 'remove')
                                        if (hasNewTag) handleUpdateUserTag(data?._id, 'review', 'remove')
                                      } else {
                                        handleUpdateUserTag(data?._id, 'review', 'add')
                                      }
                                    }}
                                  />

                                  <label
                                    className={clsx(
                                      'fw-bold fs-7 mt-3 text-nowrap',
                                       getCompletedTag('review', data?.tags) || getCompletedTag('review-request', data?.tags)
                                        ? 'text-success'
                                        : 'text-muted'
                                    )}
                                  >
                                    Review
                                  </label>
                                </div>
                                <div className='d-flex'>
                                  <input
                                    className='form-check-input me-3 mt-3'
                                    type='checkbox'
                                    checked={getCompletedTag('review-received', data?.tags) ? true : false}
                                    onChange={() => {
                                      const action = getCompletedTag('review-received', data?.tags)
                                        ? 'remove'
                                        : 'add'
                                      handleUpdateUserTag(data?._id, 'review-received', action)
                                    }}
                                  />

                                  <label
                                    className={clsx(
                                      'fw-bold fs-7 mt-3 text-nowrap',
                                      getCompletedTag('review-received', data?.tags)
                                        ? 'text-success'
                                        : 'text-muted'
                                    )}
                                  >
                                    Review Received
                                  </label>
                                </div>     
                                <div className='d-flex'>
                                  <input
                                    className='form-check-input me-3 mt-3'
                                    type='checkbox'
                                    checked={getCompletedTag('demo-booked', data?.tags) ? true : false}
                                    onChange={() => {
                                      const action = getCompletedTag('demo-booked', data?.tags)
                                        ? 'remove'
                                        : 'add'
                                      handleUpdateUserTag(data?._id, 'demo-booked', action)
                                    }}
                                  />

                                  <label
                                    className={clsx(
                                      'fw-bold fs-7 mt-3 text-nowrap',
                                      getCompletedTag('demo-booked', data?.tags)
                                        ? 'text-success'
                                        : 'text-muted'
                                    )}
                                  >
                                    Demo Booked
                                  </label>
                                </div>                           
                              </div>
                            </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <a
                            href='#'
                            className='text-dark fw-bolder text-hover-primary d-block fs-6'
                          >
                            {data?.companyName}
                          </a>
                        </td>
                        <td>
                          <a
                            href='#'
                            className='text-dark fw-bolder text-hover-primary d-block fs-6'
                          >
                            {data?.mobile}
                          </a>
                        </td>
                        <td>
                          <span
                            className={`badge badge-light-${
                              StatusColor?.[
                                data?.smsStatus === 'newUser' ? 'unverified' : 'verified'
                              ]
                            }`}
                          >
                            {data?.smsStatus === 'newUser' ? 'UnVerified' : 'Verified'}
                          </span>
                        </td>
                        <td>
                          <span className={`badge badge-light-${StatusColor?.[data?.status2]}`}>
                            {data?.status2}
                          </span>
                        </td>
                        <td
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          title={data?.tags
                            ?.filter((tag: any) => tag?.type === 'tag')
                            ?.map((tag: any) => tag?.name)
                            .join()}
                        >
                          <div className='d-flex gap-2 align-items-center flex-wrap '>
                            {data?.tags
                              ?.filter((tag: any) => tag?.type === 'tag')
                              ?.map(
                                (tag: {_id: string; name: string; color: string}, i: number) => (
                                  <div
                                    key={i}
                                    className='inbox-tags'
                                    style={{
                                      color: tag?.color ? 'white' : 'black',
                                      backgroundColor: tag?.color ? tag?.color : '',
                                    }}
                                  >
                                    {tag?.name}
                                  </div>
                                )
                              )}
                          </div>
                        </td>
                        <td>
                          <b> {data?.industry?.toUpperCase()} </b>
                        </td>
                        <td>
                          <div className='tags-wrapper'>
                            {data?.features?.map((tags: any, index: number) => {
                              return (
                                <span key={index} className={'badge badge-light-primary'}>
                                  {tags}
                                </span>
                              )
                            })}
                          </div>
                        </td>
                        <td>
                          <div>
                            {data?.accountManager?.name && (
                              <span className='text-muted fw-bold text-muted d-block fs-7 mb-2'>
                                {data?.accountManager?.name && data?.sales?.name && '-'}{' '}
                                {data?.accountManager?.name}
                              </span>
                            )}
                            {data?.sales?.name && (
                              <span className='text-muted fw-bold text-muted d-block fs-7'>
                                {data?.accountManager?.name && data?.sales?.name && '-'}{' '}
                                {data?.sales?.name}
                              </span>
                            )}

                            {!data?.accountManager?.name && !data?.sales?.name ? '-' : ''}
                          </div>
                        </td>
                        <td>
                          <div className='tags-wrapper'>
                            {data?.salesType?.toUpperCase() ?? '-'}
                          </div>
                        </td>

                        <td className='text-dark fw-bolder text-hover-primary  fs-6'>
                          {moment(data?.lastLogin).fromNow()}
                        </td>
                        <td>{data?.accountType}</td>
                        <td>
                          <a
                            href='#'
                            className='text-dark fw-bolder text-hover-primary d-block fs-6'
                          >
                            {moment(data?.createdAt).format('DD/MM/YYYY')}
                          </a>
                        </td>

                        <td>{+data?.totalPurchased.toFixed(3) || 0}</td>
                        <td>--</td>
                        <td>{data?.credit?.sms || 0 + data?.credit?.mms || 0}</td>
                        <td>{data?.lastPurchase ? moment(data?.lastPurchase).fromNow() : '-'}</td>
                        <td>{data?.lastSend ? moment(data?.lastSend).fromNow() : '-'}</td>
                        <td>{data?.lastSendSource}</td>
                        <td className='text-end'>
                          <DropdownButton
                            // menuAlign='right'
                            title={<i className='bi bi-three-dots fs-5'></i>}
                            id='dropdown-menu-align-right'
                            variant='light'
                          >
                            {AuthenticateUser('edit-user') && (
                              <Dropdown.Item
                                onClick={() => {
                                  dispatch(ProfileDetailData(data?._id))
                                  navigate(`/user-profile`)
                                }}
                                className='menu-item p-3 '
                              >
                                Edit client
                              </Dropdown.Item>
                            )}

                            {AuthenticateUser('edit-user') && (
                              <Dropdown drop='start'>
                                <Dropdown.Toggle
                                  variant='light'
                                  id='dropdown-basic'
                                  className='menu-item p-3 bg-white fw-bold text-dark'
                                >
                                  <span className='change_status'>
                                    Change status <i className='bi bi-chevron-right'></i>
                                  </span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => {
                                      dispatch(
                                        UpdateStatus({
                                          userId: data?._id,
                                          status2: 'active',
                                        })
                                      )
                                    }}
                                  >
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                      <div
                                        className='rounded-circle'
                                        style={{
                                          width: '10px',
                                          height: '10px',
                                          backgroundColor: '#50cd89 ', // Red color
                                          marginRight: '10px',
                                        }}
                                      ></div>
                                      <span className='menu-title ' style={{width: '80px'}}>
                                        Active
                                      </span>
                                      {data?.status2 === 'active' && (
                                        <Check size={20} color='#198754' />
                                      )}
                                      {/* Green check mark */}
                                    </div>
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      dispatch(
                                        UpdateStatus({
                                          userId: data?._id,
                                          status2: 'inactive',
                                        })
                                      )
                                    }}
                                  >
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                      <div
                                        className='rounded-circle'
                                        style={{
                                          width: '10px',
                                          height: '10px',
                                          backgroundColor: '#e4e6ef',
                                          marginRight: '10px',
                                        }}
                                      ></div>
                                      <span className='menu-title ' style={{width: '80px'}}>
                                        Inactive
                                      </span>
                                      {data?.status2 === 'inactive' && (
                                        <Check size={20} color='#198754' />
                                      )}
                                    </div>
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      dispatch(
                                        UpdateStatus({
                                          userId: data?._id,
                                          status2: 'suspended',
                                        })
                                      )
                                    }}
                                  >
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                      <div
                                        className='rounded-circle'
                                        style={{
                                          width: '10px',
                                          height: '10px',
                                          backgroundColor: '#dc3545', // Red color
                                          marginRight: '10px',
                                        }}
                                      ></div>
                                      <span className='menu-title' style={{width: '80px'}}>
                                        Suspended
                                      </span>
                                      {data?.status2 === 'suspended' && (
                                        <Check size={20} color='#198754' />
                                      )}
                                    </div>
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            )}

                            {/* <Dropdown.Item
                              onMouseEnter={() => handleComment(data)}
                              className=' fw-bold text-dark p-3 aside-footer flex-column-auto'
                              id='kt_drawer_chat_toggle2'
                            >
                              Comments
                            </Dropdown.Item> */}

                            {(AuthenticateUser('delete-user') || ['ryan.c@cellcast.com'].includes(userDetail?.email)) && (
                              <Dropdown.Item
                                data-kt-users-table-filter='delete_row'
                                onClick={() => handleSelect(data?._id)}
                                className='fw-bold p-3 text-danger'
                              >
                                Delete client
                              </Dropdown.Item>
                            )}
                          </DropdownButton>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className='abcd '>
                <select
                  value={page?.size}
                  className='SelectSize'
                  onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={userAccList?.total}>ALl</option>
                </select>
                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={userAccList?.totalPages}
                  onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                  containerClassName={'pagiantion'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            </div>
          </>
        ) : (
          <NodataYet />
        )}
      </div>
    </>
  )
}

export default AllCellCastUserList
